import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view on every SPA route change (auto page_view is disabled
// in index.html, so this covers the initial load and all client-side navigation).
export function Analytics() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
}

export default Analytics;
